module.exports = __webpack_public_path__ + "img/discover-2.9e75c4c.svg";